import { useEffect, useState } from "react";
import { SmartTable } from "@/components/SmartTable";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Panel } from "@/components/KpiCard";
import { PlatformBadge } from "@/components/Badges";
import { telecharger } from "@/components/RapportButtons";
import { api, cleanParams, errMsg, money, moisLabel } from "@/lib/api";

const Th = ({ children, right }) => <th className={`py-2 px-3 text-[11px] font-mono uppercase tracking-wider text-slate-500 ${right ? "text-right" : "text-left"}`}>{children}</th>;

export const CommissionsEnTropPanel = ({ periode, refreshKey }) => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    api.get("/commissions-en-trop", { params: cleanParams(periode || {}) }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periode?.debut, periode?.fin, refreshKey]);
  const lettre = async (g) => {
    const k = `${g.mois}-${g.plateforme}`;
    setBusy(k);
    try {
      const r = await api.get("/commissions-en-trop/lettre", { params: { mois: g.mois, plateforme: g.plateforme }, responseType: "blob" });
      telecharger(r.data, `Réclamation commissions ${g.plateforme} ${g.mois}.pdf`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  if (!rows) return null;
  const total = rows.reduce((s, g) => s + g.en_trop, 0);
  return (
    <Panel title={`Commissions en trop à réclamer (${money(total)})`} className="mt-6" testId="commissions-trop-panel">
      {!rows.length ? <p className="text-sm text-slate-500">Aucune commission en trop sur cette période.</p> : (
        <div className="overflow-x-auto -mx-5">
          <SmartTable id="commissions-trop" className="w-full text-sm min-w-[860px]" data-testid="commissions-trop-table">
            <thead><tr><Th>Mois</Th><Th>Plateforme</Th><Th right>Réservations</Th><Th right>Commission</Th><Th right>Attendue</Th><Th right>En trop</Th><Th right>Réclamation</Th></tr></thead>
            <tbody>
              {rows.map((g) => {
                const k = `${g.mois}-${g.plateforme}`;
                return (
                  <tr key={k} className="border-t border-slate-100 hover:bg-slate-50/70" data-testid={`comm-row-${k}`}>
                    <td className="py-3 px-3">{moisLabel(g.mois)}</td>
                    <td className="py-3 px-3"><PlatformBadge plateforme={g.plateforme} /></td>
                    <td className="py-3 px-3 text-right tabular" title={g.reservations.map((r) => r.code).join(", ")}>{g.nb}</td>
                    <td className="py-3 px-3 text-right tabular">{money(g.commission)}</td>
                    <td className="py-3 px-3 text-right tabular">{money(g.attendue)}</td>
                    <td className="py-3 px-3 text-right tabular font-semibold text-amber-700" data-testid={`comm-total-${k}`}>{money(g.en_trop)}</td>
                    <td className="py-3 px-3 text-right">
                      <Button size="sm" variant="outline" className="h-8" disabled={!!busy} onClick={() => lettre(g)} data-testid={`comm-lettre-${k}`}>
                        {busy === k ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <FileText className="h-3.5 w-3.5 mr-1" />}Lettre groupée
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </SmartTable>
        </div>
      )}
    </Panel>
  );
};
